module.exports = __webpack_public_path__ + "static/media/YM30_0.df20e6a0.jpg";